import {ApiService} from '@modules/api-service';

class RosterUtils {
  static async getRosterTemplate(format) {
    const resp = await ApiService.rosterExport(format, true);
    const url = await ApiService.getDownloadFileUrl(resp.file_key);
    window.open(url, '_blank');
  }

  static async download(rosterId) {
    try {
      const jobInfo = await ApiService.userJobGet(rosterId);
      const url = await ApiService.getDownloadFileUrl(jobInfo.params_json.data_source);
      window.open(url, '_blank');
    } catch (e) {}
  }
}

export {
  RosterUtils
};
